import { render, staticRenderFns } from "./ZBonPage.vue?vue&type=template&id=15c2ce8c&scoped=true&"
import script from "./ZBonPage.vue?vue&type=script&lang=js&"
export * from "./ZBonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2ce8c",
  null
  
)

export default component.exports